function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { raf } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import calculateNodeHeight from './calculateNodeHeight';
var __vue_script__ = {
  name: buildComponentName('Textarea'),
  inheritAttrs: false,
  props: {
    prefixCls: {
      type: String,
      default: 'ux-input'
    },
    autoSize: {
      type: [Boolean, Object],
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'light'
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    textareaStyle: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      calculatedStyle: '',
      nextFrameId: null,
      innerValue: null
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          theme = this.theme,
          disabled = this.disabled;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(theme), !!theme), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), disabled), _ref;
    },
    styles: function styles() {
      var textareaStyle = this.textareaStyle,
          calculatedStyle = this.calculatedStyle;
      return [textareaStyle, calculatedStyle];
    },
    bindListeners: function bindListeners() {
      var $listeners = this.$listeners,
          onInput = this.onInput,
          onKeydown = this.onKeydown,
          onBlur = this.onBlur;
      return _objectSpread({}, $listeners, {
        input: onInput,
        keydown: onKeydown,
        // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/230
        blur: onBlur
      });
    },
    length: function length() {
      return this.innerValue ? this.innerValue.length : 0;
    },
    limitWord: function limitWord() {
      var length = this.length,
          showWordLimit = this.showWordLimit,
          $attrs = this.$attrs;
      var maxlength = $attrs.maxlength;
      return maxlength && showWordLimit ? "".concat(length, "/").concat(maxlength) : null;
    }
  },
  watch: {
    value: function value(nVal, oVal) {
      if (nVal !== oVal) {
        this.innerValue = nVal;
      }
    },
    innerValue: function innerValue(nVal, oVal) {
      if (nVal !== oVal) {
        this.resizeTextarea();
      }
    }
  },
  created: function created() {
    this.innerValue = this.value;
  },
  methods: {
    calcTextAreaStyle: function calcTextAreaStyle(value) {
      var autoSize = this.autoSize,
          $refs = this.$refs;

      if (!this.autoSize) {
        return;
      }

      var _autoSize$minRows = autoSize.minRows,
          minRows = _autoSize$minRows === void 0 ? null : _autoSize$minRows,
          _autoSize$maxRows = autoSize.maxRows,
          maxRows = _autoSize$maxRows === void 0 ? null : _autoSize$maxRows;
      this.calculatedStyle = calculateNodeHeight($refs.textarea, value, false, minRows, maxRows);
    },
    resizeTextarea: function resizeTextarea() {
      var nextFrameId = this.nextFrameId,
          calcTextAreaStyle = this.calcTextAreaStyle,
          innerValue = this.innerValue;

      if (nextFrameId) {
        raf.cancel(nextFrameId);
      }

      this.nextFrameId = raf(function () {
        calcTextAreaStyle(innerValue);
      });
    },
    onInput: function onInput(e) {
      var value = e.target.value; // 解决 因vue异步更新数据导致textarea scrollTop值不为0,出现抖动的问题
      // this.$refs.textarea.value = this.innerValue;

      this.innerValue = value;
      this.$emit('input', value, e);
      this.$emit('on-change', e);
    },
    onChange: function onChange(e) {
      this.$emit('change', e);
    },
    onKeydown: function onKeydown(e) {
      if (e.keyCode === 13) {
        this.$emit('on-press-enter', e);
        this.$emit('pressenter', e); // return;
      }

      this.$emit('on-key-down', e);
      this.$emit('keydown', e);
    },
    // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/230
    onBlur: function onBlur(e) {
      this.$emit('blur', e);
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.showWordLimit ? _c('div', {
    class: _vm.prefixCls + "-textarea-wrapper"
  }, [_c('textarea', _vm._g(_vm._b({
    ref: "textarea",
    class: _vm.classes,
    style: _vm.styles,
    attrs: {
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.innerValue
    }
  }, 'textarea', _vm.$attrs, false), _vm.bindListeners)), _vm._v(" "), _vm.limitWord ? _c('span', {
    class: _vm.prefixCls + "-limit-word"
  }, [_vm._v(_vm._s(_vm.limitWord))]) : _vm._e()]) : _c('textarea', _vm._g(_vm._b({
    ref: "textarea",
    class: _vm.classes,
    style: _vm.styles,
    attrs: {
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.innerValue
    }
  }, 'textarea', _vm.$attrs, false), _vm.bindListeners));
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "textarea.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;